// Alle Inhalte des Fischereiverein Fürth e.V. – zunächst als Mock-Daten.
// Bilder sind Platzhalter (Unsplash) und werden spaeter durch eigene Fotos ersetzt.

export const club = {
  name: "Fischerei Verein Fürth e.V.",
  shortName: "FV Fürth",
  founded: 1881,
  slogan: "Petri Heil seit 1881",
  logo: "/assets/g3a4crrm_Logo_FVF_PNG_5d13e1aa.webp",
  address: {
    heim: "Vereinsheim Amtsgasse 2",
    city: "90768 Fürth / Vach",
  },
  emails: {
    vorstand: "vorstand@fischereiverein-fuerth.de",
    anfrage: "anfrage@fischereiverein-fuerth.de",
    gewaesserwart: "gewaesserwart@fischereiverein-fuerth.de",
  },
  chairman: "Martin Stade",
  hejfish: "https://www.hejfish.com/m/fischereiverein-fuerth-e-v-2196",
  pruefung: "http://fischereischulung.de/",
  permit: {
    title: "Jahres-Fischerei-Erlaubnis 2026",
    valid: "Gültig vom 11.01.2026 bis zum 10.01.2027",
    jubilee: "145 Jahre",
    note: "Es gelten die gesetzlichen Schonmaße und Schonzeiten der AVBayFiG sowie der Bezirksfischereiordnung Mittelfranken.",
  },
};

export const navItems = [
  { label: "Start", to: "/" },
  { label: "Verein", to: "/verein" },
  { label: "Gewässer", to: "/gewaesser" },
  { label: "Termine", to: "/termine" },
  { label: "Bestimmungen", to: "/bestimmungen" },
  { label: "Gastkarten", to: "/gastkarten" },
  { label: "Jugend", to: "/jugend" },
  { label: "Kontakt", to: "/kontakt" },
];

export const images = {
  waldmannsweiher: "/assets/gh4malqj_Waldmannsweiher_b360016d.webp",
  waldsee: "/assets/pcnehxxi_Waldsee_NEU_a807280b.webp",
  altmuehl: "/assets/ay1xcuu2_Altmu_hl_ea9201d4.webp",
  woernitz: "/assets/xly07k8v_Wo_rnitz_NEU_6ede7505.webp",
  rastsee: "/assets/cd67vkb0_Rastsee_099ef91d.webp",
  schwarzeLaber: "/assets/gns6equc_Schwarze_Laber_29db245f.webp",
  hofweiher: "/assets/wh7bz60m_Hofweiher_78653d47.webp",
  farrnbach: "/assets/ennwdqct_Farrnbach_01_3b800e6e.webp",
  ludwigskanal: "/assets/bi4gfedz_Ludwigskanal_Neu_8d37abe0.webp",
  eichensee: "/assets/6ajvz7az_Eichensee_02_e93f69ce.webp",
  beckenweiher: "/assets/0h6ibys6_Beckenweiher_02_0ff26f9b.webp",
  altbach: "/assets/rd1w1y8n_Altbach_Neu_08917747.webp",
  eulensee: "/assets/buvewy21_Eulensee_02_17393d24.webp",
  farrnbach2: "/assets/z3jssdlk_Farrnbach_02_75b2adb1.webp",
  fuchsenweiher: "/assets/vnv4v2hs_Fuchsenweiher_02_172487c4.webp",
  haidenaab: "/assets/z6eoi19r_Haidenaab_1_02_cd77f739.webp",
  herrenweiher: "/assets/49jsfxff_Herrenweiher_02_fc757644.webp",
  regnitz: "/assets/g7r3a0vz_Regnitz_274bb025.webp",
  sulzach: "/assets/5wsamy1t_Sulzach_NEU_010350c1.webp",
  rodlersee: "/assets/rdc3eqf5_Rodlersee_f1f6c337.webp",
  stierlingsweiher: "/assets/tj9r2jvv_Stierlingsweiher_NEU_4a0f36a2.webp",
  stierwiese: "/assets/uf09yrn0_Stierwiese_8aca3774.webp",
  vils: "/assets/lujvg5g5_Vils_NEU_fa69ad38.webp",
  waldsee2: "/assets/28sr8664_Waldsee_2_NEU_50ea3cfd.webp",
  zenn: "/assets/xy0mkbe5_Zenn_NEU_a908eb3b.webp",
  wiesensee: "/assets/eqekxdiy_Wiesensee_NEU_be76a37c.webp",
  heroLakeSunrise: "/assets/photo-1528164604878-28ea0fb4f462_e7d60668.webp",
  calmLake: "/assets/photo-1597060330071-69c1ac998254_c41712c5.webp",
  boatSunset: "/assets/photo-1596796571148-77b6e70dd6b6_0359f33a.webp",
  riverGreen: "/assets/photo-1600972051891-82c2d7db699c_8282415a.webp",
  meadowLake: "/assets/photo-1588598737105-bb94155abc26_04372007.webp",
  anglerMountain: "/assets/photo-1493787039806-2edcbe808750_ee854f07.webp",
  anglerAutumn: "/assets/photo-1604336102823-1a4df72dfa26_dd10a6cc.webp",
  anglerMisty: "/assets/photo-1632862316541-0b75b0126544_adb68830.webp",
  kidToddler: "/assets/photo-1550504473-08c751f3349f_87c3fe02.webp",
  kidFish: "/assets/photo-1592918746966-5ba08b5e2ae5_80649999.webp",
};

// Wird automatisch aus dem aktuellen Jahr berechnet (Gründung 1881).
export const yearsOfTradition = new Date().getFullYear() - club.founded;

export const stats = [
  { value: "1881", label: "Gegründet" },
  { value: String(yearsOfTradition), label: "Jahre Tradition" },
  { value: "32", label: "Gewässer" },
  { value: "6", label: "Verkaufsstellen" },
];

export const waters = [
  {
    id: "waldmannsweiher",
    name: "Waldmannsweiher",
    type: "Weiher",
    image: images.waldmannsweiher,
    description:
      "Unser idyllischer Waldmannsweiher – von grünen Ufern und Seerosen gesäumt. Ein Naturjuwel mit gutem Bestand, perfekt für ruhige und entspannte Angeltage.",
    fish: ["Karpfen", "Schleie", "Rotauge", "Hecht"],
  },
  {
    id: "waldsee",
    name: "Waldsee",
    type: "See",
    image: images.waldsee,
    description:
      "Unser weitläufiger Waldsee, eingebettet in ausgedehnte Kiefern- und Mischwälder. Ein herrlicher See mit klarem Wasser – ein Paradies für Raubfisch- und Karpfenangler.",
    fish: ["Hecht", "Zander", "Karpfen", "Barsch"],
  },
  {
    id: "altmuehl",
    name: "Die Altmühl",
    type: "Fluss",
    image: images.altmuehl,
    description:
      "Unser naturnaher Abschnitt der mäandrierenden Altmühl – eingebettet in weite grüne Auen. Ein wunderschönes Fließgewässer für Fliegen- und Spinnangler.",
    fish: ["Bachforelle", "Döbel", "Barbe", "Aitel"],
  },
  {
    id: "woernitz",
    name: "Die Wörnitz",
    type: "Fluss",
    image: images.woernitz,
    description:
      "Unser Eigengewässer an der Wörnitz – ein malerischer Flussabschnitt vor imposanter Felskulisse, ruhig fließend und fischreich.",
    fish: ["Hecht", "Döbel", "Barbe", "Rotauge"],
  },
  {
    id: "hofweiher",
    name: "Hofweiher",
    type: "Weiher",
    image: images.hofweiher,
    description:
      "Der Hofweiher bei Kreben – ein klassischer, gut erreichbarer Weiher inmitten sanfter Felder. Beliebt bei Friedfisch- und Karpfenanglern.",
    fish: ["Karpfen", "Schleie", "Zander", "Rotauge"],
  },
  {
    id: "schwarze-laber",
    name: "Schwarze Laber",
    type: "Fluss",
    image: images.schwarzeLaber,
    description:
      "Die Schwarze Laber – ein naturbelassener Wiesenbach mit klarem Wasser und dichtem Uferbewuchs. Ein Kleinod für Angler, die Ruhe und Natur suchen.",
    fish: ["Bachforelle", "Döbel", "Aitel"],
  },
  {
    id: "rastsee",
    name: "Rastsee",
    type: "See",
    image: images.rastsee,
    description:
      "Der Rastsee bei Etzenricht – ein stimmungsvoller Waldsee mit herrlichen Spiegelungen und einer der Austragungsorte unseres Königsfischens.",
    fish: ["Hecht", "Karpfen", "Schleie", "Barsch"],
  },
];

// Vollständiges Gewässerverzeichnis laut Erlaubnisschein 2026
export const waterList = [
  { nr: 1, name: "Waldmannsweiher", type: "Weiher", note: "in Fürth", img: images.waldmannsweiher, coords: [49.475109, 10.979643] },
  { nr: 2, name: "Zenn I", type: "Fluss", note: "Brücke Ritzmannshof bis Wehrabfall Flexdorf (Eigengewässer)", img: images.zenn, coords: [49.509225, 10.946925] },
  { nr: 3, name: "Zenn II", type: "Fluss", note: "unterhalb Wehrabfall Flexdorf bis Einlauf Regnitz (Eigengewässer)", img: images.zenn, coords: [49.516595, 10.963505] },
  { nr: 4, name: "Farrnbach I", type: "Fluss", note: "100 m unterhalb Viadukt bis Mündung Regnitz", img: images.farrnbach, coords: [49.494173, 10.954421] },
  { nr: 5, name: "Farrnbach II", type: "Fluss", note: "bei Hiltmannsdorf bis Weinmühle Burgfarrnbach", img: images.farrnbach2, coords: [49.485350, 10.910892] },
  { nr: 6, name: "Ludwigskanal Worzeldorf", type: "Kanal", note: "Schleuse 65–69", img: images.ludwigskanal, coords: [49.372164, 11.101717] },
  { nr: 7, name: "Hofweiher", type: "Weiher", note: "bei Kreben", img: images.hofweiher, coords: [49.446801, 10.720703] },
  { nr: 8, name: "Altmühl", type: "Fluss", note: "Eigengewässer", img: images.altmuehl, coords: [49.316611, 10.387389] },
  { nr: 9, name: "Wörnitz", type: "Fluss", note: "Wehrabfall Wittelshofen bis Mühle Aufkirchen (Eigengewässer)", img: images.woernitz, coords: [49.057282, 10.490625] },
  { nr: 10, name: "Sulzach", type: "Fluss", note: "Wehr Oberkemmathen bis Mühle Dorfkemmathen", img: images.sulzach, coords: [49.094445, 10.440521] },
  { nr: 11, name: "Eichensee", type: "See", note: "bei Burggrafenhof", img: images.eichensee, coords: [49.473814, 10.761162] },
  { nr: 12, name: "Rodler-See", type: "See", note: "in Dießfurt (Eigengewässer)", img: images.rodlersee, coords: [49.731570, 11.965477] },
  { nr: 13, name: "Waldsee", type: "See", note: "in Dießfurt (Eigengewässer)", img: images.waldsee, coords: [49.732921, 11.965213] },
  { nr: 14, name: "Eulensee", type: "See", note: "Göggelsbuch (Eigengewässer)", img: images.eulensee, coords: [49.236608, 11.226206] },
  { nr: 15, name: "Haidenaab I", type: "Fluss", note: "bei Pressath", img: images.haidenaab, coords: [49.766990, 11.929880] },
  { nr: 16, name: "Stierlingsweiher", type: "Weiher", note: "", img: images.stierlingsweiher, coords: [49.474348, 10.759201] },
  { nr: 17, name: "Schwarze Laber", type: "Fluss", note: "", img: images.schwarzeLaber, coords: [49.068100, 11.874060] },
  { nr: 18, name: "Pegnitz", type: "Fluss", note: "bei Fürth, Engelhardtsteg bis Friedhofsteg", coords: [49.478756, 10.996221] },
  { nr: 19, name: "Vils", type: "Fluss", note: "Lengenfeld bis Wehranlage Theuern (Eigengewässer)", img: images.vils, coords: [49.398815, 11.904500] },
  { nr: 20, name: "Beckenweiher", type: "Weiher", note: "bei Hammerbach", img: images.beckenweiher, removeFrom: "31.10.2026" },
  { nr: 21, name: "Haidenaab II", type: "Fluss", note: "Kahrmühle", coords: [49.750135, 11.948935] },
  { nr: 22, name: "Regnitz", type: "Fluss", note: "bei Hüttendorf bis Schleuse Kriegenbrunn", img: images.regnitz, coords: [49.550650, 10.976400] },
  { nr: 23, name: "Schwarzach", type: "Fluss", note: "bei Unterölsbach", coords: [49.356280, 11.426515] },
  { nr: 24, name: "Herrenweiher", type: "Weiher", note: "bei Kreben", img: images.herrenweiher, coords: [49.446564, 10.716626] },
  { nr: 25, name: "Wiesensee", type: "See", note: "bei Etzenricht", img: images.wiesensee, coords: [49.620260, 12.099427] },
  { nr: 26, name: "Fuchsenweiher", type: "Weiher", note: "bei Burggrafenhof", img: images.fuchsenweiher, coords: [49.474502, 10.756622] },
  { nr: 27, name: "Rastsee", type: "See", note: "bei Etzenricht", img: images.rastsee, coords: [49.615505, 12.112985] },
  { nr: 28, name: "Haidenaab III", type: "Fluss", note: "ab Haberstumpfmühle", coords: [49.620570, 12.106355] },
  { nr: 29, name: "Waldsee II", type: "See", note: "", img: images.waldsee2, coords: [49.618632, 12.102412] },
  { nr: 30, name: "Stierwiese", type: "Weiher", note: "bei Etzenricht", img: images.stierwiese, coords: [49.619099, 12.103880] },
  { nr: 31, name: "Altbach", type: "Bach", note: "", img: images.altbach, coords: [49.100911, 10.435089] },
  { nr: 32, name: "Kleiner Hofweiher", type: "Weiher", note: "" },
];

// Prüft, ob ein Datum in einer jährlich wiederkehrenden Periode liegt.
// from/to sind [Monat, Tag] (Monat 1-basiert). Perioden über den Jahreswechsel
// werden unterstützt (from > to, z. B. [10,1]–[3,31]).
export function isDateInRecurringRange(from, to, date = new Date()) {
  const y = date.getFullYear();
  const start = new Date(y, from[0] - 1, from[1], 0, 0, 0);
  const end = new Date(y, to[0] - 1, to[1], 23, 59, 59);
  if (start <= end) {
    return date >= start && date <= end;
  }
  return date >= start || date <= end; // über Jahreswechsel
}

// ============================================================
// GEWÄSSERSPERREN & FANGEINSCHRÄNKUNGEN (aus der Fischereiordnung)
// ------------------------------------------------------------
// Zentrale Liste aller offiziellen Regelungen. Der Status wird automatisch
// anhand des aktuellen Datums berechnet – inkl. Vorwarnung einige Tage vorher.
//
// Felder je Eintrag:
//   type:   "closure" (Vollsperrung) | "restriction" (Fangeinschränkung) | "usage" (Nutzung)
//   scope:  "all" (alle Gewässer) ODER Array von Gewässernamen
//   period: { from:[Monat,Tag], to:[Monat,Tag] } ODER "permanent"
// ============================================================
export const waterRestrictions = [
  {
    id: "altbach-schonzeit",
    title: "Schonzeit-Sperrung",
    type: "closure",
    scope: ["Altbach"],
    period: { from: [1, 1], to: [6, 30] },
    rangeLabel: "01.01.–30.06.",
    description:
      "Der Altbach ist während der Schonzeit vom 01.01. bis 30.06. für die Angelfischerei gesperrt.",
  },
  {
    id: "friedfisch-besatzzeit",
    title: "Kein Friedfischangeln (Besatzzeit)",
    type: "restriction",
    scope: "all",
    period: { from: [11, 2], to: [11, 30] },
    rangeLabel: "02.11.–30.11.",
    description:
      "Während der Besatzzeit ist das Angeln auf Friedfische untersagt – außer auf Köderfische mit Hakengröße 14–16 oder kleiner (frisch eingesetzte Fische dürfen mind. 2 Wochen nicht beangelt werden).",
  },
  {
    id: "camper-winter",
    title: "Camper nicht unbewohnt abstellen",
    type: "usage",
    scope: "all",
    period: { from: [11, 3], to: [2, 28] },
    rangeLabel: "03.11.–28.02.",
    description:
      "Vom 03.11. bis einschl. 28.02. dürfen Camper an keinem Vereinsgewässer unbewohnt stehen bleiben.",
  },
  {
    id: "koeder-jungzander",
    title: "Köderbeschränkung (Schutz Jungzander)",
    type: "restriction",
    scope: ["Hofweiher"],
    period: "permanent",
    rangeLabel: "dauerhaft",
    description:
      "Köderfische und Köderfischteile sowie Kunstköder unter 10 cm sind verboten. Spinner ab Größe 5 oder größer sind erlaubt.",
  },
  {
    id: "beckenweiher-abgefischt",
    title: "Gesperrt (abgefischt)",
    type: "closure",
    scope: ["Beckenweiher"],
    period: "permanent",
    rangeLabel: "bis 30.10.2026",
    description:
      "Der Beckenweiher wurde abgefischt und ist bis zur Abgabe des Gewässers gesperrt. Ab dem 31.10.2026 gehört der Beckenweiher nicht mehr zu unseren Gewässern.",
  },
];

// Anzahl Tage im Voraus, ab wann eine Vorwarnung angezeigt wird.
export const RESTRICTION_NOTICE_DAYS = 5;

function stripTime(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}
function daysBetween(a, b) {
  return Math.round((stripTime(b) - stripTime(a)) / 86400000);
}
function formatDayMonth(d) {
  return `${String(d.getDate()).padStart(2, "0")}.${String(d.getMonth() + 1).padStart(2, "0")}.`;
}

// Berechnet das Timing einer Periode relativ zum heutigen Datum.
// Rückgabe: { state: "active" | "upcoming" | "inactive", daysUntil, startDate, startLabel }
export function getRestrictionTiming(period, date = new Date(), noticeDays = RESTRICTION_NOTICE_DAYS) {
  if (period === "permanent") {
    return { state: "active", daysUntil: 0, startDate: null, startLabel: null };
  }
  if (isDateInRecurringRange(period.from, period.to, date)) {
    return { state: "active", daysUntil: 0, startDate: null, startLabel: null };
  }
  const y = date.getFullYear();
  let start = new Date(y, period.from[0] - 1, period.from[1]);
  if (daysBetween(date, start) < 0) {
    start = new Date(y + 1, period.from[0] - 1, period.from[1]);
  }
  const daysUntil = daysBetween(date, start);
  const startLabel = formatDayMonth(start);
  if (daysUntil >= 0 && daysUntil <= noticeDays) {
    return { state: "upcoming", daysUntil, startDate: start, startLabel };
  }
  return { state: "inactive", daysUntil, startDate: start, startLabel };
}

function restrictionAppliesTo(restriction, water) {
  return (
    restriction.scope === "all" ||
    (Array.isArray(restriction.scope) && restriction.scope.includes(water.name))
  );
}

// Wandelt "TT.MM.JJJJ" in ein Date um.
function parseGermanDate(str) {
  const [d, m, y] = str.split(".").map(Number);
  return new Date(y, m - 1, d);
}

// Ableitung von Gewässersperren aus Terminen (Arbeitsdienst/Umweltschutztag).
// Aktiv genau am Termintag, Vorwarnung `noticeDays` Tage vorher.
export function getEventClosures(date = new Date(), noticeDays = RESTRICTION_NOTICE_DAYS) {
  return events
    .filter((e) => e.closesWaters)
    .map((e) => {
      const start = parseGermanDate(e.date);
      const daysUntil = daysBetween(date, start);
      let state = "inactive";
      if (daysUntil === 0) state = "active";
      else if (daysUntil > 0 && daysUntil <= noticeDays) state = "upcoming";
      return {
        id: `event-${e.date}`,
        title: e.title,
        type: "closure",
        scope: e.closesWaters,
        rangeLabel: e.date,
        description: `An diesem Tag gesperrt (${e.title}).`,
        timing: { state, daysUntil, startDate: start, startLabel: formatDayMonth(start) },
      };
    });
}

// Liefert alle aktuell aktiven ODER demnächst startenden Regelungen für ein Gewässer
// (wiederkehrende Regeln + terminbasierte Sperren).
export function getWaterNotices(water, date = new Date()) {
  const recurring = waterRestrictions
    .filter((r) => restrictionAppliesTo(r, water))
    .map((r) => ({ ...r, timing: getRestrictionTiming(r.period, date) }))
    .filter((r) => r.timing.state === "active" || r.timing.state === "upcoming");
  const eventBased = getEventClosures(date).filter(
    (e) =>
      (e.scope === "all" || (Array.isArray(e.scope) && e.scope.includes(water.name))) &&
      (e.timing.state === "active" || e.timing.state === "upcoming")
  );
  return [...eventBased, ...recurring];
}

// Zusammenfassung für Kartenmarker / Kartenkarten.
export function getWaterStatus(water, date = new Date()) {
  const notices = getWaterNotices(water, date);
  const locked = notices.some((n) => n.type === "closure" && n.timing.state === "active");
  return { notices, locked };
}

// Prüft, ob ein Gewässer aktuell noch zum Verein gehört.
// Gewässer mit `removeFrom` verschwinden ab diesem Datum automatisch.
export function isWaterActive(w, date = new Date()) {
  if (!w.removeFrom) return true;
  return date < parseGermanDate(w.removeFrom);
}

// Alle aktuell gültigen Gewässer (ohne bereits abgegebene).
export function getActiveWaters(date = new Date()) {
  return waterList.filter((w) => isWaterActive(w, date));
}

// Prüft, ob eine Regelung noch mindestens ein aktives Gewässer betrifft.
function restrictionHasActiveScope(r, date) {
  if (r.scope === "all") return true;
  if (!Array.isArray(r.scope)) return true;
  const active = getActiveWaters(date).map((w) => w.name);
  return r.scope.some((name) => active.includes(name));
}

// Alle Regelungen + kommende Termin-Sperren mit Status, sortiert nach Datum.
// Regelungen für bereits abgegebene Gewässer werden ausgeblendet.
export function getSortedRestrictions(date = new Date()) {
  const recurring = waterRestrictions
    .filter((r) => restrictionHasActiveScope(r, date))
    .map((r) => ({
      ...r,
      timing: getRestrictionTiming(r.period, date, 366),
    }));
  const eventBased = getEventClosures(date, 366).filter(
    (e) => e.timing.daysUntil >= 0 && restrictionHasActiveScope(e, date)
  );
  return [...recurring, ...eventBased].sort((a, b) => {
    const rank = (s) => (s === "active" ? 0 : s === "upcoming" ? 1 : 2);
    const byState = rank(a.timing.state) - rank(b.timing.state);
    if (byState !== 0) return byState;
    return (a.timing.daysUntil ?? 0) - (b.timing.daysUntil ?? 0);
  });
}

// Vereinsheimöffnungen 2026 (Montage)
// Vereinsheim ist jeweils montags von 18:00 bis ca. 21:00 Uhr geöffnet.
export const openingTime = "18:00 – ca. 21:00 Uhr";

export const openings = [
  { date: "02.02.2026", note: "Kartenausgabe" },
  { date: "23.02.2026", note: "Kartenausgabe" },
  { date: "02.03.2026", note: "" },
  { date: "20.04.2026", note: "" },
  { date: "04.05.2026", note: "" },
  { date: "08.06.2026", note: "" },
  { date: "13.07.2026", note: "" },
  { date: "05.10.2026", note: "" },
  { date: "16.11.2026", note: "" },
  { date: "14.12.2026", note: "" },
];

// Termine 2026 laut Erlaubnisschein.
// closesWaters: an diesem Tag gesperrte Gewässer (Arbeitsdienst/Umweltschutztag).
//   "all" = alle Gewässer, Array = konkrete Gewässernamen (müssen exakt zu waterList passen).
export const events = [
  { date: "14.06.2026", title: "Damenfischen", type: "Veranstaltung" },
  { date: "11.07.2026", title: "Arbeitsdienst Hof- und Herrenweiher", type: "Arbeitsdienst", closesWaters: ["Hofweiher", "Herrenweiher"] },
  { date: "19.07.2026", title: "Königs- und Hegefischen", type: "Veranstaltung" },
  { date: "25.07.2026", title: "Arbeitsdienst Waldsee/Rodlersee", type: "Arbeitsdienst", closesWaters: ["Waldsee", "Rodler-See"] },
  { date: "13.09.2026", title: "Stadtwaldfest", type: "Veranstaltung" },
  { date: "17.10.2026", title: "Arbeitsdienst Hof- und Herrenweiher", type: "Arbeitsdienst", closesWaters: ["Hofweiher", "Herrenweiher"] },
  { date: "18.10.2026", title: "Apfelmarkt Fürth", type: "Veranstaltung" },
  { date: "24.10.2026", title: "Arbeitsdienst Waldsee/Rodlersee", type: "Arbeitsdienst", closesWaters: ["Waldsee", "Rodler-See"] },
  { date: "31.10.2026", title: "Umweltschutztag (alle Gewässer gesperrt)", type: "Veranstaltung", closesWaters: "all" },
  { date: "01.11.2026", title: "Stichtag Änderungen der Mitgliedschaft", type: "Hinweis" },
  { date: "14.11.2026", title: "Arbeitsdienst Farrnbach II", type: "Arbeitsdienst", closesWaters: ["Farrnbach II"] },
  { date: "28.11.2026", title: "Arbeitsdienst Rastsee", type: "Arbeitsdienst", closesWaters: ["Rastsee"] },
  { date: "13.12.2026", title: "Adventsmarkt Burgfarrnbach", type: "Veranstaltung" },
  { date: "10.01.2027", title: "Jahreshauptversammlung 2027", type: "Veranstaltung" },
];

// Mitgliedschaft / Warteliste-Anfrage
export const membershipRequest = {
  recipient: "anfrage@fischereiverein-fuerth.de",
  subject: "Eintrag auf die Warteliste",
  intro:
    "Vielen Dank für dein Interesse an einer Mitgliedschaft im Fischerei-Verein Fürth! Bitte hab Verständnis dafür, dass wir mehrere Anfragen bündeln, bevor wir zu einem persönlichen Termin einladen. Ein Gespräch findet also erst statt, wenn die nächste Aufnahmegruppe startet.",
  situation: {
    title: "Aktuelle Situation",
    points: [
      "Die frühesten Aufnahmen finden voraussichtlich im Februar 2027 statt.",
      "Es gibt eine Warteliste, auf die wir dich gerne setzen.",
      "Für Jugendliche kann der Einstieg schneller gehen.",
      "Ein späterer Gesprächstermin bedeutet noch keine Zusage – dort klären wir offene Fragen und erklären den Ablauf.",
    ],
  },
  sections: [
    {
      title: "Kosten",
      items: [
        "Aufnahmegebühr: 480 € (Jugendliche zahlen keine Aufnahmegebühr; sie wird erst mit 18 Jahren beim Übertritt fällig)",
        "Jahresbeitrag: 243 €",
        "Jugendliche: 110 € jährlich",
      ],
    },
    {
      title: "Arbeitsdienst",
      items: [
        "6 Arbeitsstunden pro Jahr (ab dem 16. Lebensjahr)",
        "Mehrstunden sind freiwillig, werden aber gerne gesehen",
      ],
    },
    {
      title: "Probejahr",
      items: [
        "Das erste Jahr gilt als Probejahr",
        "Über die Übernahme entscheidet die Verwaltung gemeinsam mit den Wasserwarten",
      ],
    },
    {
      title: "Zuteilung im Probejahr",
      items: [
        "Du wirst einem Gewässer zugeteilt, das von einem unserer Wasserwarte betreut wird",
        "Die Aufgaben reichen von Gewässerpflege über Kontrollgänge bis zu Fischbesatzmaßnahmen und gehen über die 6 Pflichtstunden hinaus",
        "Deine Einsatzbereitschaft fließt in die Übernahmeentscheidung ein",
      ],
    },
    {
      title: "Zahlungen",
      items: [
        "Beiträge und Gebühren werden per SEPA-Lastschrift eingezogen",
        "Ratenzahlung bieten wir nicht an",
      ],
    },
  ],
  benefits: [
    "Aktuell 32 Gewässer in und um Fürth, Nürnberg, Regensburg, Weiden, Grafenwöhr, Jochsberg u. v. m.",
    "Stehende und fließende Gewässer",
    "Friedfisch- und Raubfischmöglichkeiten",
    "Verbandskarte ab dem 2. Mitgliedsjahr (+80 €)",
    "Nachtangeln erlaubt",
    "Hauptkommunikation per E-Mail und Vereins-App",
    "Eigene Jugendgruppe mit Zeltlagern",
    "Veranstaltungen & Feste über das Jahr verteilt",
  ],
  acceptLabel:
    "Ich habe die oben genannten Rahmenbedingungen gelesen und bin mit ihnen einverstanden.",
};


export const salesPoints = [
  { name: "Joachim Dorn", address: "Maxstraße 29, 90762 Fürth" },
  { name: "Fisherman´s Partner", address: "Stravinsky Straße 28, 90455 Nürnberg" },
  { name: "Sportangler-Zentrale", address: "Rothenburger Straße 253, 90439 Nürnberg" },
  { name: "Angelshop-Erlangen", address: "Noethestraße 61, 91058 Erlangen-Bruck" },
  { name: "CS Angelshop", address: "Im Gewerbepark 4, 91093 Heßdorf" },
  { name: "Baitschmiede", address: "Hauptstraße 49, 91452 Wilhermsdorf" },
];

export const youthInfo = {
  intro:
    "Die Jugendgruppe des FV Fürth begeistert junge Menschen für das Angeln, den Gewässer- und Naturschutz. Gemeinsam entdecken wir die heimische Unterwasserwelt – mit Spaß, Verantwortung und viel frischer Luft.",
  activities: [
    { title: "Gemeinsame Angeltage", text: "Regelmäßige Treffen an unseren Gewässern unter fachkundiger Anleitung." },
    { title: "Naturschutz", text: "Wir lernen ökologische Zusammenhänge kennen und pflegen unsere Gewässer." },
    { title: "Ausflüge & Feste", text: "Vereinsfeste, Königsfischen und Aktionen für die ganze Familie." },
  ],
};

export const historyTimeline = [
  { year: "1881", title: "Gründung", text: "Der Fischerei Verein Fürth wird gegründet – der Beginn einer langen Tradition." },
  { year: "1900", title: "Wachstum", text: "Der Verein wächst und übernimmt Verantwortung für die Pflege lokaler Gewässer." },
  { year: "1970", title: "Gewässerschutz", text: "Aktiver Einsatz für Umwelt- und Gewässerschutz in der Region Fürth." },
  { year: "Heute", title: "Lebendige Gemeinschaft", text: "Ein moderner Verein mit Jugendarbeit, Veranstaltungen und Online-Angelkarten." },
];

// Gemeinnütziger Vereinszweck (§2 der Satzung, öffentlich aufbereitet)
export const purpose = {
  intro:
    "Als gemeinnütziger, eingetragener Verein verfolgen wir ausschließlich Ziele zum Wohl von Natur, Fischerei und Gemeinschaft.",
  goals: [
    { title: "Gewässer schützen", text: "Schutz und Erhaltung unserer Gewässer in ihrer natürlichen Schönheit – samt ihrem Fischbestand." },
    { title: "Umwelt bewahren", text: "Abwehr und Bekämpfung schädlicher Einflüsse und Einwirkungen auf Fischbestand und Gewässer." },
    { title: "Nachhaltig hegen", text: "Hege, Pflege und eine ordnungsgemäße, nachhaltige Befischung unserer Vereinsgewässer." },
    { title: "Mitglieder fördern", text: "Beratung, Ausbildung und Förderung unserer Mitglieder in allen Fragen der Fischerei." },
    { title: "Jugend begeistern", text: "Ausbildung und Förderung der Vereinsjugend im Sinne unserer Ziele und Aufgaben." },
    { title: "Zusammenarbeiten", text: "Unterstützung von Behörden sowie Zusammenarbeit mit Fischereiorganisationen und nahestehenden Vereinigungen." },
  ],
};

// Mitgliedsarten (§3 der Satzung)
export const membership = {
  intro:
    "Bei uns ist jede und jeder willkommen, der die Liebe zur Natur und zum Angeln teilt.",
  types: [
    { title: "Aktive Mitglieder", text: "Angler ab 18 Jahren – zugleich Mitglied im zuständigen Fischereiverband." },
    { title: "Passive Mitglieder", text: "Fördernde Mitglieder, die den Verein und seine Ziele unterstützen." },
    { title: "Jugendliche", text: "Junge Menschen unter 18 Jahren – mit Zustimmung der Eltern in unserer Jugendgruppe." },
    { title: "Ehrenmitglieder", text: "Für besondere Verdienste um den Verein ernannte Mitglieder." },
  ],
};


// ===== Bestimmungen 2026 (aus dem Erlaubnisschein) =====

// Schonmaße & Schonzeiten
export const closedSeasons = [
  { fish: "Aal", size: "50 cm", season: "01.10. – 31.12." },
  { fish: "Äsche", size: "35 cm", season: "01.01. – 30.04." },
  { fish: "Bachforelle", size: "28 cm", season: "01.10. – 15.03." },
  { fish: "Barbe", size: "50 cm", season: "01.05. – 30.06." },
  { fish: "Frauennerfling", size: "keines", season: "ganzjährig" },
  { fish: "Hecht", size: "60 cm", season: "15.02. – 30.04." },
  { fish: "Karpfen", size: "35 cm", season: "keine" },
  { fish: "Edelkrebs", size: "12 cm", season: "01.10. – 31.07." },
  { fish: "Nase", size: "30 cm", season: "01.03. – 30.04." },
  { fish: "Nerfling", size: "30 cm", season: "01.03. – 30.04." },
  { fish: "Regenbogenforelle", size: "28 cm", season: "15.12. – 15.03." },
  { fish: "Rutte", size: "40 cm", season: "keine" },
  { fish: "Schied (Rapfen)", size: "40 cm", season: "01.03. – 30.04." },
  { fish: "Schleie", size: "28 cm", season: "01.05. – 30.06." },
  { fish: "Zander", size: "50 cm", season: "15.02. – 30.04." },
  { fish: "Wels", size: "keines", season: "keine" },
];

export const alwaysProtected =
  "Ganzjährig geschont: Karausche, Neunaugen, Bitterling, Schneider, Schrätzer, Sichling, Steinbeißer, Steingressling, Stichling, Sterlet sowie alle Muschelarten.";

// Fangbeschränkungen
export const catchLimits = {
  weekly: [
    "2 Aale",
    "3 Karpfen",
    "2 Schleien",
    "2 Hecht oder Zander",
    "4 Salmoniden",
    "5 Edelkrebse",
    "Signalkrebse ohne Beschränkung",
  ],
  daily: [
    "8 Weißfische (z. B. Rotauge, Rotfeder, Giebel, Nerfling)",
  ],
  yearly: [
    "30 Karpfen",
    "15 Schleien",
    "25 Salmoniden",
    "8 Hechte",
    "5 Zander",
    "25 Edelkrebse",
    "10 Aale",
    "Alle übrigen Arten max. 30 Stück/Jahr",
    "Waller, Signalkrebse, Grundeln & Sonnenbarsche frei",
  ],
  note: "Die Fischerwoche beginnt am Montag und endet am Sonntag.",
};

// Gastregelung
export const guestRules = [
  "Jedes Mitglied darf pro Besuch maximal 1 Gast mitnehmen.",
  "Für den Gast ist vorab eine gültige Tageskarte online über hejfish zu erwerben.",
  "Das Mitglied ist für das Verhalten des Gastes verantwortlich und haftet für ihn.",
  "Der Gast darf nur im direkten Sicht- und Rufkontakt des Mitglieds angeln.",
  "Für Gäste gilt ein Angelverbot zwischen 24:00 und 5:00 Uhr.",
  "Für Gäste besteht ein generelles Campingverbot.",
];

export const guestWaters = [
  "Ludwigskanal bei Worzeldorf (oberhalb Straße nach Kornburg bis nächstes Schleusentor)",
  "Zenn (unterhalb Straßenbrücke Vach flussabwärts bis zur Mündung)",
  "Waldmannsweiher in Fürth",
  "Fuchsenweiher bei Burggrafenhof",
];

// Wichtigste Punkte der Fischereiordnung (zusammengefasst)
export const rules = [
  { title: "Ausweispflicht", text: "Staatlicher Fischereischein und Vereins-Erlaubnisschein sind stets mitzuführen und den Kontrollorganen auf Verlangen vorzuzeigen." },
  { title: "Zwei Handangeln", text: "Pro Gewässer sind zwei Handangeln mit je einer Anbissstelle gestattet. Reserve-Angeln dürfen nicht beködert sein." },
  { title: "Waidgerechtes Gerät", text: "Kescher, Maßband, Betäubungsgerät, Messer und Hakenlöser sind immer mitzuführen. Lebende Köderfische sind verboten." },
  { title: "Fangeintragung", text: "Jeder gefangene Fisch ist unverzüglich zu messen und ins Fangbuch einzutragen. Vor Beginn sind Datum und Gewässerstrecke zu notieren." },
  { title: "Schonung zurücksetzen", text: "Untermaßige oder in der Schonzeit gefangene, überlebensfähige Fische sind zwingend zurückzusetzen." },
  { title: "Natur & Ordnung", text: "Flurschäden vermeiden, Müll mitnehmen, Rücksicht auf Uferangler nehmen. Kein offenes Feuer, kein Baden in Vereinsgewässern." },
  { title: "Eigenverzehr", text: "Gefangene Fische dienen ausschließlich dem eigenen Verzehr. Verkauf, Tausch und Weitergabe sind verboten." },
  { title: "Streaming-Verbot", text: "Das Posten/Streamen von Inhalten, die Fische an Land, den Drill oder die Versorgung zeigen, ist streng untersagt." },
];

// Bußgeldkatalog (Auszug)
export const fines = [
  { offense: "Fischen mit lebendem Köderfisch", amount: "1.000 €" },
  { offense: "Verwendung verbotener Fangmittel (Netze, Strom, Sprengstoff u. a.)", amount: "500 €" },
  { offense: "Töten von Fischen ohne Betäuben", amount: "500 €" },
  { offense: "Missachtung des Streaming-Verbots", amount: "500 €" },
  { offense: "Hinterlassen von Müll am Gewässer", amount: "500 €" },
  { offense: "Offenes Feuer / Holzkohlegrill (außer erlaubte Stellen)", amount: "500 €" },
  { offense: "Nichtbeachtung von Fangbeschränkungen", amount: "300 €" },
  { offense: "Fehlender Eintrag gefangener Fische", amount: "300 €" },
  { offense: "Fischen mit mehr als 2 Handangeln", amount: "250 €" },
  { offense: "Fischen in gesperrten Gewässern", amount: "250 €" },
  { offense: "Mitnahme von Fischen in Schonzeit / unter Schonmaß", amount: "200 €" },
  { offense: "Nicht-Mitführen der Angelerlaubnis", amount: "100 €" },
];

// Arbeitsdienst
export const workDuty = {
  intro: "Alle Mitglieder von dem Jahr, in dem sie 16 werden, bis einschließlich des Jahres, in dem sie 62 werden, leisten jährlich 6 Arbeitsstunden.",
  points: [
    "Personen mit Schwerbehindertenausweis (mind. 60 %) sind befreit.",
    "Termine werden über die Vereins-App veröffentlicht.",
    "Ein Arbeitsdienst kann nicht nur teilweise abgeleistet werden; Mehrarbeit wird nicht übertragen.",
    "Für jede nicht geleistete Stunde sind 50 € zu zahlen (fällig bis Ende Februar des Folgejahres).",
  ],
};

// Digitaler Erlaubnisschein
export const digitalPermit = {
  title: "Digitaler Erlaubnisschein ab 2027",
  text: "Für 2026 gibt es den Erlaubnisschein wie gewohnt im Heft. Ab 2027 stellen wir Erlaubnisscheine und Mitgliedskarten digital über Angelflix bereit – sicher per QR-Code, jederzeit auf dem Smartphone abrufbar.",
  printNote: "Wer eine gedruckte Variante möchte, meldet sich bitte bis spätestens 1.11. per E-Mail an anfrage@fischereiverein-fuerth.de.",
};

// Inhalte des geschützten Mitgliederbereichs.
// Downloads sind zunächst Platzhalter (href "#") und werden später mit echten Dateien verknüpft.
export const memberArea = {
  intro: {
    eyebrow: "Nur für Mitglieder",
    title: "Mitgliederbereich",
    subtitle:
      "Melde dich mit deinem EasyVerein-Konto an, um Satzung, Fahrgenehmigungen und aktuelle Gewässer-Informationen abzurufen.",
  },
  documents: [
    {
      id: "satzung",
      title: "Vereinssatzung",
      desc: "Aktuelle, neu abgestimmte Satzung des Fischerei Verein Fürth e.V.",
      meta: "PDF",
      href: "/assets/zqx1wlgs_FVF_Satzung_NEU_abgestimmt_3cf7c712.pdf",
    },
    {
      id: "fischereiordnung",
      title: "Fischereiordnung & Gebühren",
      desc: "Gewässerordnung, Regeln und aktuelle Gebührenübersicht.",
      meta: "PDF",
      href: "/assets/1qcpzmy6_Fischereiordnung_und_Gebu_hren_0947a748.pdf",
    },
    {
      id: "fahrgenehmigung",
      title: "Fahrberechtigung / Ausnahmegenehmigung",
      desc: "Ausnahmegenehmigung für die Zufahrt – gültig bis 2029.",
      meta: "PDF · gültig bis 2029",
      href: "/assets/1i15o9y5_Ausnahmegenehmigung_Fahrberecht_5b8233b5.pdf",
    },
  ],
  quickLinks: [
    { id: "termine", label: "Vereinstermine", to: "/termine" },
    { id: "bestimmungen", label: "Schonzeiten & Bestimmungen", to: "/bestimmungen" },
    { id: "gewaesser", label: "Gewässerverzeichnis", to: "/gewaesser" },
  ],
};


// ============================================================
// AKTUELLE ANKÜNDIGUNG (z. B. Veranstaltungs-Flyer)
// Wird prominent auf der Startseite gezeigt und verschwindet nach dem
// Veranstaltungstag (date) automatisch. Master-Schalter: active.
// ============================================================
export const announcement = {
  active: true,
  title: "27. Stadtwaldfest",
  date: "13.09.2026", // letzter Anzeigetag (inkl.)
  dateLabel: "Sonntag, 13. September 2026",
  time: "10:30 – 17:00 Uhr",
  location: "Fürther Stadtwald, Zum Vogelsang (beim Hotel Forsthaus)",
  text: "Der Fischerei Verein Fürth ist wieder mit dabei – mit Speisen & Getränken. Komm vorbei und feiere mit uns im Stadtwald!",
  image: "/assets/stadtwaldfest-flyer.webp",
  pdf: "/assets/stadtwaldfest-flyer.pdf",
};

// Sichtbar bis einschließlich Veranstaltungstag; danach automatisch aus.
export function isAnnouncementVisible(a = announcement, date = new Date()) {
  if (!a || !a.active) return false;
  const end = parseGermanDate(a.date);
  end.setHours(23, 59, 59, 999);
  return date <= end;
}
